/*
 * Module for controlling kbLocales search for available languages
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "backbone.syphon",
  "modules/accountAdmin/kbWizardModal/kbLocales/kbLocalesSearch/kbLocalesSearchView",
], function (Marionette, Backbone, _, Messenger, BackboneSyphon, KbLocalesSearchView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbLanguageAvailable";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },
    show: function (kb) {
      this.kb = kb;
      this.view = new KbLocalesSearchView.kbLanguageAvailableSearchView({ model: this.kb });
      this.locales = this.kb.getLocales();
      this.allLanguages = Messenger.reqres.request("fetch:kb:allLanguages", this.kb.get("kbId"));

      this.allLanguages.onSynced(function () {
        //If this a new KB, then add English (US) as the default
        if (!this.editMode && this.locales.length === 0) {
          const defaultLocale = this.allLanguages.findWhere({ id: 1 });
          Messenger.vent.trigger("add:admin:kbWizard:kbLocale:languages:add", defaultLocale);
        }
        this.showRegion(this.view);
      }, this);

      this.view.on(
        "click:addLanguage",
        function (args) {
          const data = BackboneSyphon.serialize(args.view);
          let languageName;
          if (data.searchField) {
            languageName = data.searchField.trim();
          } else {
            languageName = "";
          }
          const language = this.allLanguages.findWhere({ name: languageName });
          Messenger.vent.trigger("add:admin:kbWizard:kbLocale:languages:add", language);
        },
        this,
      );
    },
    //used by parent modules to change the search mode programmatically
    changeSearchMode: function (modeNumber) {
      if (this.view) {
        this.view.model.set("mode", modeNumber);
      }
    },
    //trigger search externally using this function if we want to cause a search to happen without hitting the search
    // button
    triggerSearch: function () {
      if (this.view) {
        this.view.trigger("click:addLanguage", { view: this.view }); //pass in the view as an argument
      }
    },

    _setUpVents: function () {
      Messenger.vent.on(
        "update:kb:language:add:clearInput",
        function () {
          this.view.clearInput();
        },
        this,
      );
    },
  });
});
